import { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

// MUI Theme Setup
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "assets/theme";
// Components
import Navbar from "components/Navbar";
import Footer from "components/Footer/Footer";
import MKBox from "components/MKBox";
import Preloader from "components/Preloader";
import { routes } from "routes";
import CookieConsent from "react-cookie-consent";
import { hasConsented, hasDeclined } from "./utils/cookieUtils";
import { loadGoogleAnalytics } from "./utils/loadAnalytics";

export default function App() {
  const { pathname } = useLocation();
  const [loading, setLoading] = useState(true); // ⏳ Show Preloader first

  // Hide preloader after 2.5s
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2500);
    return () => clearTimeout(timer);
  }, []);

  // Scroll to top on route change
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);
  //  Cookie Consent Logic (runs once)
  useEffect(() => {
    if (hasConsented()) {
      console.log(" Cookies accepted");
      loadGoogleAnalytics();
    } else if (hasDeclined()) {
      console.log(" Cookies declined");
      // Future: Block tracking or remove scripts
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      {/*  If loading, ONLY show Preloader */}
      {loading ? (
        <Preloader />
      ) : (
        <MKBox display="flex" flexDirection="column" minHeight="100vh">
          <Navbar />
          <MKBox flex="1">
            <Routes>
              {routes.map(({ route, component }, index) => (
                <Route key={index} path={route} element={component} />
              ))}
            </Routes>
          </MKBox>
          <Footer />
          {/* Cookie Banner Here */}
          <CookieConsent
            location="bottom"
            buttonText="Accept"
            declineButtonText="Decline"
            enableDeclineButton
            cookieName="matrix180_cookie_consent"
            style={{
              background: "#2B373B",
              fontSize: "14px",
              padding: "16px",
              textAlign: "center",
            }}
            buttonStyle={{
              color: "#ffffff",
              backgroundColor: "#28738a",
              fontSize: "13px",
              borderRadius: "4px",
              padding: "8px 16px",
            }}
            declineButtonStyle={{
              color: "#ffffff",
              backgroundColor: "#9e2b2b",
              fontSize: "13px",
              borderRadius: "4px",
              padding: "8px 16px",
              marginLeft: "8px",
            }}
            onDecline={() => {
              console.log("User declined cookies");
            }}
            onAccept={() => {
              console.log("User accepted cookies");
            }}
            expires={150}
          >
            We use cookies to enhance your browsing experience. By clicking
            <strong> Accept</strong>, you consent to our use of cookies. See our{" "}
            <a href="/privacy" style={{ color: "#f1d600", textDecoration: "underline" }}>
              Privacy Policy
            </a>
          </CookieConsent>
        </MKBox>
      )}
    </ThemeProvider>
  );
}
